import { changeProgramType } from 'legacy/lut/features/partner360/configuration'
import { listenerMiddleware } from 'legacy/lut/store/middlewares/listenerMiddleware'

import { getUrlParam } from 'core-components/helpers/url'
import { PID_URL } from 'partner360/configs'

import { setCockpitOffering } from '../model'

const hasPid = () => Boolean(getUrlParam(PID_URL))

listenerMiddleware.startListening({
  predicate: (action): action is ReturnType<typeof changeProgramType.fulfilled> =>
    changeProgramType.fulfilled.match(action) && hasPid(),
  effect: (action, { dispatch }) => {
    dispatch(setCockpitOffering(action.payload))
  },
})
